export interface PasswordValidationResult {
  valid: boolean;
  errors: string[];
}

/**
 * Validate password strength according to rules:
 * - Minimum 12 characters
 * - At least 1 letter
 * - At least 1 digit
 */
export function validatePassword(password: string): PasswordValidationResult {
  const errors: string[] = [];

  if (password.length < 12) {
    errors.push("Le mot de passe doit contenir au moins 12 caractères");
  }

  const hasLetter = /[a-zA-Z]/.test(password);
  if (!hasLetter) {
    errors.push("Le mot de passe doit contenir au moins une lettre");
  }

  const hasDigit = /\d/.test(password);
  if (!hasDigit) {
    errors.push("Le mot de passe doit contenir au moins un chiffre");
  }

  return {
    valid: errors.length === 0,
    errors,
  };
}
